// src/redux/pageFilters/pageFilterSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GridSortModel } from '@mui/x-data-grid';

type FilterValue = string | number | boolean | null | undefined;
type PageFilters = Record<string, FilterValue>;

interface PageState {
  filters: PageFilters | null;
  sorting: GridSortModel | null;
}

type PageFiltersState = Record<string, PageState>;

const initialState: PageFiltersState = {};

const pageFilterSlice = createSlice({
  name: 'pageFilters',
  initialState,
  reducers: {
    setPageFilters(state, action: PayloadAction<{ pageKey: string; filters: PageFilters }>) {
      const { pageKey, filters } = action.payload;
      if (!state[pageKey]) state[pageKey] = { filters: null, sorting: null };
      state[pageKey].filters = filters;
    },

    updatePageFilters(
      state,
      action: PayloadAction<{ pageKey: string; filters: Partial<PageFilters> }>,
    ) {
      const { pageKey, filters } = action.payload;
      if (!state[pageKey]) state[pageKey] = { filters: null, sorting: null };
      state[pageKey].filters = { ...(state[pageKey].filters ?? {}), ...filters };
    },

    clearPageFilters(state, action: PayloadAction<string>) {
      const pageKey = action.payload;
      if (state[pageKey]) state[pageKey].filters = null;
    },

    // ── Sorting ──────────────────────────────────────────────
    setPageSorting(state, action: PayloadAction<{ pageKey: string; sorting: GridSortModel }>) {
      const { pageKey, sorting } = action.payload;
      if (!state[pageKey]) state[pageKey] = { filters: null, sorting: null };
      state[pageKey].sorting = sorting;
    },

    clearPageSorting(state, action: PayloadAction<string>) {
      const pageKey = action.payload;
      if (state[pageKey]) state[pageKey].sorting = null;
    },
  },
});

export const {
  setPageFilters,
  updatePageFilters,
  clearPageFilters,
  setPageSorting,
  clearPageSorting,
} = pageFilterSlice.actions;

export default pageFilterSlice.reducer;
